import {
  triggerCardsInView,
  tirggerInView,
  triggerAboutInView,
  triggerHeaderImgInView,
  triggerFooterInView,
  // triggerTextScroll,
} from "./observers";
import { animatePageOut } from "./animations";
import imageLightbox from "./gallery";
import controlVideo from "./vimeo-controls";
import initCursor from "./cursor";
import initPersonMovement from "./person-items";
import initSmoothScroll from "./smooth";
import initTitles from "./smoothTitles";
// import { mainAnim } from "./lottie";
import initVideoMovement from "./video-movement";
import initHashScroll from "./hash-scroll";
import initCookie from "./cookie";
import setPostTitlesHeight from "./setPostsTitlesHeight";
import { slogansSlider } from "./sliders";
import initMotionAnimations from "./motionAnimations";
import initCountUp from "./countup";
import setCareerPageHeaderHeight from "./setSingleCareerHeaderHeight";

imageLightbox();
controlVideo();
triggerCardsInView();
tirggerInView();
triggerAboutInView();
triggerHeaderImgInView();
triggerFooterInView();
// triggerTextScroll();
initCursor();
initPersonMovement();
// initSmoothScroll();
animatePageOut();
// mainAnim();
initVideoMovement();
initHashScroll();
slogansSlider();

initTitles();

initCookie();
setPostTitlesHeight();
initMotionAnimations();
initCountUp();

function openMenu() {
  function init() {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".mobile-menu");

    hamburger.addEventListener("click", () => {
      hamburger.classList.toggle("is-active");
      menu.classList.toggle("is-open");
      document.body.classList.toggle("mobile-menu-open");
    });

    const items = document.querySelectorAll(".mobile-nav a");

    items.forEach((item) => {
      item.addEventListener("click", () => {
        hamburger.click();
      });
    });
  }

  const isPresent = document.getElementsByClassName("hamburger");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();

document.body.classList.add("custom-cursor-activated");

// remove js-animate-out class on browser back click
window.addEventListener("pageshow", function (event) {
  var pagehistory =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (pagehistory) {
    // back button event - Do whatever.
    console.log("back");
    if (document.body.classList.contains("js-animate-out")) {
      document.body.classList.remove("js-animate-out");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  setCareerPageHeaderHeight();
});
